<template>
    <v-container container--fluid grid-list-lg>
        <v-flex xs12 class="text-center elevation-24">
            <v-row align="center" justify="center">
                <v-col cols="12" align-self="stretch" class="py-0">
                    <v-card class="pa-4" flat tile>
                        <div class="primary align-center justify-center py-4">
                            <p class="body-1 white--text font-weight-bold ma-0 text-uppercase">Welcome to {{ appNameUrls.client }} Online Platform</p>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="4" align-self="stretch" class="card-divider">
                    <v-card class="pa-4 pb-0 align-start justify-center" flat tile>
                        <v-icon x-large color="secondary lighten-2">fas fa-user-circle</v-icon>
                        <p class="subtitle text-center mt-2 font-weight-bold red--text text--lighten-2">Previously registered</p>
                        <p class="body-2 text--secondary text-center">If you have previously registered and know your username and password.</p>
                    </v-card>
                    <v-btn class="ma-2 primary--text" color="grey lighten-3" :to="{ name: 'login', query: { redirect: this.$route.query.redirect } }"
                        >Sign In<v-icon dark right>launch</v-icon></v-btn
                    >
                </v-col>
                <v-col cols="12" sm="4" align-self="stretch" class="card-divider">
                    <v-card class="pa-4 pb-0 align-start justify-center" flat tile>
                        <v-icon x-large color="secondary lighten-2">fas fa-list-alt</v-icon>
                        <p class="subtitle text-center mt-2 font-weight-bold red--text text--lighten-2">Previously registered<br />but don't know my username or password</p>
                        <p class="body-2 text--secondary text-center">
                            If you have previously played at {{ appNameUrls.assoc_name }} you'll already have an account. If you use the same email the system will match your
                            history. Click below to obtain your username or reset your password.
                        </p>
                    </v-card>
                    <v-btn outlined small class="ma-2 secondary--text pa-2" :to="{ name: 'username-email' }">Forgot Username<v-icon medium dark right>fingerprint</v-icon></v-btn>
                    <v-btn outlined small class="ma-2 secondary--text pa-2" :to="{ name: 'password-email' }">Reset Password<v-icon medium dark right>cached</v-icon></v-btn>
                </v-col>
                <v-col cols="12" sm="4" align-self="stretch">
                    <v-card class="pa-4 pb-0 align-start justify-center" flat tile>
                        <v-icon x-large color="secondary lighten-2">fas fa-address-card</v-icon>
                        <p class="subtitle text-center mt-2 font-weight-bold red--text text--lighten-2">Create an account</p>
                        <p class="body-2 text--secondary text-center">
                            If creating an account, you must create in the name of the participant. Data must match Birth Certificate &/or Active & Creative Kids Voucher.
                        </p>
                    </v-card>
                    <v-btn class="ma-2" color="primary" :to="{ name: 'register' }">CREATE<v-icon dark right>input</v-icon></v-btn>
                </v-col>
                <v-col cols="12" align-self="stretch" class="py-0">
                    <v-card class="pa-4" flat tile>
                        <div class="primary align-center justify-center py-4">
                            <p class="caption white--text text-left font-weight-bold ma-0 px-4">By logging in or creating a login to the {{ appNameUrls.client }} Online Platform, you declare that you have read, understood, acknowledge and agree to the <a class="white--text" href="https://australia.basketball/wp-content/uploads/2019/09/The-Basketball-Network-Participant-Terms-and-Conditions.pdf" target="_blank">basketball Network Participant Terms and Conditions</a> and <a class="white--text" href="https://australia.basketball/integrity/" target="_blank">basketball Australia National Integrity Framework</a>, including the exclusion of implied terms, warning, assumption of risk, release and indemnity. In addition, you agree that you will be bound by {{ appNameUrls.assoc_name }} constitution and any regulations and policies (including competition rules or by-laws) made under it. <a class="white--text" href="/about/policy-procedures/" target="_blank">Click here</a> to view {{ appNameUrls.assoc_name }} Competition By-Laws, policies and procedures.</p>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-flex>
    </v-container>
</template>

<script>
export default {
    name: "Home",
    components: {
        //
    },
    data() {
        return {
            //
        };
    },
};
</script>

<style scoped>
.card-divider {
    border-right: 1px #eeeeee solid;
}
@media screen and (max-width: 767px) {
    .card-divider {
        border-right: 0px #eeeeee solid;
        border-bottom: 1px #eeeeee solid;
    }
}
</style>
